import { getStateThunkValues, type TBaseAsyncAction } from '@core/store'

import { readVisitsCounter, writeVisitsCounter } from '../helpers/visitsCounter'
import { sessionDialogStore } from './sessionDialogStore'

export const giveBackNextjsExitVisit: TBaseAsyncAction<void> = () => (dispatch, getState) => {
    const [pendingNextjsExit] = getStateThunkValues(
        [sessionDialogStore.props.getPendingNextjsExit],
        getState,
    )

    if (!pendingNextjsExit) {
        return
    }

    dispatch(sessionDialogStore.actions.setPendingNextjsExit(false))
    writeVisitsCounter(Math.max(readVisitsCounter() - 1, 0))
}
